export default __webpack_public_path__ + "static/media/t2Sala4.7ac9e6bd.jpg";